var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Emit, Prop } from 'vue-property-decorator';
import { Dependencies } from "~/core/decorator";
import { TelCaseManageService } from "~/services/domain-service/tel-case-manage.service";
var PrincipalRecovery = /** @class */ (function (_super) {
    __extends(PrincipalRecovery, _super);
    function PrincipalRecovery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataForm = {
            ids: [],
            recoveryType: ''
        };
        _this.checkMessages = {};
        _this.rules = {
            recoveryType: { required: true, message: "请选择回收方式" },
        };
        _this.submitLoading = false;
        _this.dialog = false;
        return _this;
    }
    PrincipalRecovery.prototype.emitClose = function () {
        this.resetDate();
    };
    /**
     * 提交
     */
    PrincipalRecovery.prototype.commit = function () {
        var _this = this;
        var dataFrom = this.$refs["dataFrom"];
        dataFrom.validate(function (valid) {
            if (!valid)
                return false;
            _this.submit();
        });
    };
    /**
     * 提交接口调用
     */
    PrincipalRecovery.prototype.submit = function () {
        this.submitLoading = true;
        this.dataForm.ids = this.ids;
        this.telCaseManageService
            .dealManualPartReturnCase(this.dataForm)
            .subscribe(this.success, this.error);
    };
    /**
     * 申请成功
     */
    PrincipalRecovery.prototype.success = function (data) {
        if (data && data.status !== 2) {
            this.checkMessages = data;
            this.dialog = true;
        }
        else {
            this.submitLoading = false;
            this.$message.success("操作成功");
            this.emitClose();
        }
    };
    /**
     * 失败
     */
    PrincipalRecovery.prototype.error = function () {
        this.submitLoading = false;
    };
    /**
     * 取消
     */
    PrincipalRecovery.prototype.cancelContinue = function () {
        this.dialog = false;
        this.submitLoading = false;
    };
    /**
     * 继续提交
     */
    PrincipalRecovery.prototype.confirmSubmit = function () {
        this.dataForm.confirm = 1;
        this.submit();
    };
    /**
     * 数据重置
     */
    PrincipalRecovery.prototype.resetDate = function () {
        this.dataForm = {
            ids: [],
            recoveryType: ''
        };
        var form = this.$refs["dataFrom"];
        form.resetFields();
        this.checkMessages = {};
    };
    __decorate([
        Dependencies(TelCaseManageService)
    ], PrincipalRecovery.prototype, "telCaseManageService", void 0);
    __decorate([
        Prop({ type: Array, required: true })
    ], PrincipalRecovery.prototype, "ids", void 0);
    __decorate([
        Prop({ type: String })
    ], PrincipalRecovery.prototype, "fromChannel", void 0);
    __decorate([
        Emit('close')
    ], PrincipalRecovery.prototype, "emitClose", null);
    PrincipalRecovery = __decorate([
        Component({
            components: {}
        })
    ], PrincipalRecovery);
    return PrincipalRecovery;
}(Vue));
export default PrincipalRecovery;
